<template>
  <div class="father-module flex flex-v">
    <div
      class="title-module flex flex-align-center flex-pack-justify"
      v-if="choosedEqType.mark"
    >
      <img
        src="@/assets/image/layout/mod-title.png"
        alt=""
        class="title-module-img"
      />
      <div class="flex flex-align-center">
        <img
          class="icon bridgeInfo"
          src="@/assets/image/layout/eq_type.png"
          alt=""
        />
        <span>设备说明</span>
      </div>
      <a
        href="javascript:;"
        @click="
          () => {
            $router.back()
          }
        "
        class="more"
        >桥梁列表</a
      >
    </div>
    <div class="baseinfo" v-if="choosedEqType.mark">
      <div class="name" style="font-weight: normal">
        {{ choosedEqType.equipmentTypeName }}
      </div>
      <img class="mt10" src="@/assets/image/layout/line.png" alt="" />
      <div class="mt8">{{ choosedEqType.mark || '暂无说明' }}</div>
    </div>
    <div class="title-module flex flex-align-center flex-pack-justify">
      <img
        src="@/assets/image/layout/mod-title.png"
        alt=""
        class="title-module-img"
      />
      <div class="flex flex-align-center">
        <img
          class="icon bridgeInfo"
          src="@/assets/image/layout/bridgeInfo.png"
          alt=""
        />
        <span>桥梁信息</span>
      </div>
      <a
        v-if="!choosedEqType.mark"
        href="javascript:;"
        @click="
          () => {
            $router.back()
          }
        "
        class="more"
        >桥梁列表</a
      >
    </div>
    <div class="baseinfo">
      <div class="name">{{ bridgeObj.bridgeName }}</div>
      <div class="addr flex flex-align-center mt10">
        <img src="@/assets/image/layout/addr.png" alt="" />
        <span>{{ bridgeObj.address }}</span>
      </div>
      <img class="mt10" src="@/assets/image/layout/line.png" alt="" />
      <div
        class="mt8"
        v-html="bridgeObj.introduce"
        style="word-break: break-all"
      ></div>
    </div>

    <div
      class="title-module flex flex-align-center flex-pack-justify"
      v-if="bridgeObj.biBridgeCameraList.length > 0"
    >
      <img
        src="@/assets/image/layout/mod-title.png"
        alt=""
        class="title-module-img"
      />
      <div class="flex flex-align-center">
        <img class="icon" src="@/assets/image/layout/video.png" alt="" />
        <span>桥梁监控</span>
      </div>
    </div>
    <div class="videolist">
      <div
        class="video-item"
        v-for="(item, index) in bridgeObj.biBridgeCameraList"
        @click="showVideoList(item.cameraUrl)"
        :key="index"
      >
        <img src="@/assets/image/layout/demo.jpg" alt="" srcset="" />
        <div class="cover"></div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <!-- <div class="leftTop">
			<div class="title">
				<div class="title-child">
					<img class="titleIcon" src="@/assets/image/qiaoliang.png" />
					<div class="titleMian">桥梁列表</div>
				</div>
			</div>
			<div class="active-qiao">
				<div class="active-qiao-img"><img style="width: 100%;" src="../../../assets/image/lightqiao.png" alt="" /></div>

				<span class="active-qiao-text">{{ bridgeObj.bridgeName }}</span>
			</div>
			<div class="qiao-list">
				<div class="qiao-list-title">
					<div v-for="(item, index) in qiaoLiangData" :key="index" @click="btnclick(index)" :class="index !== active ? 'item-title' : 'title-active'">{{ item.name }}</div>
				</div>
				<div class="qiao-item-list">
					<div v-for="(item, index) in qiaoLiangData[active].list" :key="index" @click="imgClick(item)" class="qiao-item-list-item">{{ item.bridgeName }}</div>
				</div>
			</div>
		</div> -->
  </div>
</template>

<script>
export default {
  name: 'leftTop',
  data() {
    return {
      qiaoLiangVal: '',
      active: 0,
      qiaoLiangData: [
        {
          name: '新安江街道',
          list: []
        }
        // {
        // 	name: '康乾街道',
        // 	list: []
        // },
        // {
        // 	name: '舞阳街道',
        // 	list: []
        // },
        // {
        // 	name: '阜溪街道',
        // 	list: []
        // }
      ],
      facList: []
    }
  },
  props: {
    qiaoLiangList: {
      type: Array,
      default: []
    },
    bridgeObj: {
      type: Object,
      default: {}
    },
    choosedEqType: {
      type: Object,
      default: {}
    }
  },
  watch: {
    Object: {
      deep: true,
      handler(newName, oldName) {
        if (newName != oldName) {
          console.log(this.qiaoLiangData)
          this.qiaoLiangData.forEach((item, i) => {
            // if(item.name==this.Object.ascriptionName){
            // 	this.active=i
            // }
          })
        }
      }
    }
  },
  components: {},
  methods: {
    btnclick(index) {
      console.log(index)
      this.active = index
    },
    imgClick(item) {
      console.log(item)
      this.$router.push(`/facility/${item.bridgeUuid}`)
      this.$emit('leftClick')
    },
    //获取设施列表
    async getFac() {
      const res = await this.$api.sendGet('/biBridge/getBiBridgeScreenList')
      this.facList = res.data
      this.facList.forEach((item) => {
        if (item.ascriptionName == '新安江街道') {
          this.qiaoLiangData[0].list.push(item)
        } else if (item.ascriptionName == '康乾街道') {
          this.qiaoLiangData[1].list.push(item)
        } else if (item.ascriptionName == '舞阳街道') {
          this.qiaoLiangData[2].list.push(item)
        } else if (item.ascriptionName == '阜溪街道') {
          this.qiaoLiangData[3].list.push(item)
        } else {
        }
      })
      // console.log('设施列表',res);
    },
    showVideoList(cameraUrl) {
      this.$emit('showVideoList', cameraUrl)
    }
  },
  computed: {},

  created() {},
  mounted() {
    this.getFac()
  },
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.father-module {
  height: 100%;
  overflow: auto;
}

.father-module .title-module .icon.bridgeInfo {
  width: 16px;
  height: 18px;
}

.mt8 {
  margin-top: 8px;
}

.mt10 {
  margin-top: 10px;
}

.ml40 {
  margin-left: 40px;
}

.baseinfo {
  // margin-top: 16px;
  color: #dedede;
  font-size: 14px;
  text-align: left;
  margin-bottom: 20px;

  img {
    display: block;
    width: 100%;
  }

  .name {
    font-weight: 800;
    font-size: 16px;
    color: #fff;
  }

  .addr {
    font-size: 16px;
    margin: 9px 0;

    img {
      margin-right: 6px;
      width: 12px;
      height: 14px;
    }
  }
}

.videolist {
  margin-top: 12px;

  .video-item {
    width: 100%;
    height: 180px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .cover {
      content: '';
      display: block;
      width: 38px;
      height: 38px;
      background: url('~@/assets/image/layout/play.png');
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    & + .video-item {
      margin-top: 26px;
    }

    .name {
      color: #fff;
      position: absolute;
      font-size: 14px;
      left: 13px;
      bottom: 7px;
    }

    &.video-item-sm {
      width: calc(50% - 10px);
      height: 84px;

      .name {
        font-size: 12px;
      }

      .cover {
        width: 21px;
        height: 21px;
      }
    }
  }
}

.leftTop {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  .title {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 30px;

    .title-child {
      width: 50%;
      display: flex;
      align-items: center;

      .titleIcon {
        width: 20px;
        height: 20px;
      }

      .titleMian {
        margin-left: 10px;
        color: #ffffff;
        line-height: 30px;
        font-size: 18px;
      }
    }
  }

  .active-qiao {
    margin: 20px 0;

    .active-qiao-img {
      width: 88px;
      height: 70px;
      margin: 0 auto;
    }

    .active-qiao-text {
      display: inline-block;
      margin: 10px auto 0;
      width: 88px;
      height: 24px;
      background: linear-gradient(
        90deg,
        rgba(56, 112, 139, 0) 0%,
        #2786b3 49%,
        rgba(56, 112, 139, 0) 100%
      );
      font-size: 18px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0px 2px 4px rgba(255, 255, 255, 0.34);
    }
  }

  .qiao-list {
    .qiao-list-title {
      width: 360px;
      border-radius: 20px;
      background: #0d333a;
      display: flex;
      align-items: center;
      font-weight: 400;
      color: #4e94a6;

      .item-title {
        width: 25%;
        // padding: 5px 10px;
      }

      .title-active {
        width: 25%;
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        background: #4e94a6;
      }
    }

    .qiao-item-list {
      width: 100%;
      height: 110px;
      overflow: hidden;
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      align-items: center;
      overflow: auto;

      .qiao-item-list-item {
        margin-bottom: 20px;
        // width: 80px;
        margin-right: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #4e94a6;
        line-height: 21px;
      }

      .qiao-item-list-item:hover {
        color: #ccc;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 20px;
}

::-webkit-scrollbar-track {
  background: #0d333a;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #208091;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #142857;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:active {
  background-color: #142857;
  border-radius: 5px;
}

.el-input {
  background: transparent;
}

::v-deep .el-input__inner {
  background: #0d333a;
  border-radius: 4px;
  border: 1px solid #1c9bb1;
  color: #3c75f7;
}

::v-deep .el-input--small .el-input__icon {
  color: #1c9bb1;
}
</style>
